<h2 mat-dialog-title>راهنمایی سایت</h2>
<mat-dialog-content class="mat-typography">
  <div *ngIf="data.imageName">
    <img src="assets/images/{{data.imageName}}">
  </div>
  <div *ngIf="data.innerHtml">
    <div [innerHTML]="data.innerHtml"></div>
  </div>
  <div *ngIf="!data.imageName && !data.innerHtml">
    <p>
      no content
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>تایید</button>
</mat-dialog-actions>
